import { render, staticRenderFns } from "./ProjectSharedView.vue?vue&type=template&id=2298d5be&scoped=true"
import script from "./ProjectSharedView.vue?vue&type=script&lang=js"
export * from "./ProjectSharedView.vue?vue&type=script&lang=js"
import style0 from "./ProjectSharedView.vue?vue&type=style&index=0&id=2298d5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298d5be",
  null
  
)

export default component.exports